//  Node imports
import { FreeGameController, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher, ingenuity, Meter } from "@quest/base-core";

export class FreeGameControllerGame extends FreeGameController {
    private jackpotMeter: Meter;
    /**
   * subscribeEvents method overrided for subscribe Jackpot Meter
   */
    protected subscribeEvents(): void {
        super.subscribeEvents();
        dispatcher.on(eventDispatchers.UPDATE_JACKPOT_METER_VALUE_FG, this.updateJackpotMeterValue, this);
    }

    /**
   * initializeComponents method overrided for initialize Jackpot Meter component
   */
    protected initializeComponents(): void {
        super.initializeComponents();
        this.jackpotMeter = this.view.getMeterById("jackpotMtr") as Meter;
    }

    /**
     * updateJackpotMeterValue updates jackot meter value depends on current bet
     */
    protected updateJackpotMeterValue(): void {
        let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
        const fixedJackpotAmount: number = currentBet * ingenuity.configData.fixedJackpotAmount; //update multiplier values from server - dependancy 
        this.jackpotMeter.setCurrencyFormattedValue(fixedJackpotAmount.toString());
        this.view.getContainerByID("jpContAllign").pivot.set(this.view.getContainerByID("jpContAllign").width / 2, 0);
    }

    /**
    * Override to update Jackpot Meter Value
    */
    protected onShowFreeGame(): void {
        super.onShowFreeGame();
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
        dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METER_VALUE_FG);
        if ((ingenuity.configData.turboEnabled) && (ingenuity.configData.turboEnabled === true)) {
            this.activateTurboMode();
        }
        else {
            this.deactivateTurboMode();
        }
    }

}
